export default "__VITE_ASSET__Bf_UMFe8__"